// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"06208633","256":"b50a1150","360":"14edc85a","598":"d55898f6","614":"a692654d","743":"1bf4521e","835":"913390af","891":"63f11798"}[chunkId] + ".chunk.js";
};